document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('[data-hero-carousel]');
  if (!carousel) return;

  const track = carousel.querySelector('[data-carousel-track]');
  const slides = Array.from(carousel.querySelectorAll('[data-slide]'));
  const paginationItems = carousel.querySelectorAll('[data-pagination]');
  const prevBtn = carousel.querySelector('[data-carousel-prev]');
  const nextBtn = carousel.querySelector('[data-carousel-next]');

  if (slides.length <= 1) {
    const pagination = carousel.querySelector('.hero-carousel__pagination');
    if (pagination) pagination.style.display = 'none';
    return;
  }

  // Clone first slide and append to end for infinite loop
  const firstSlideClone = slides[0].cloneNode(true);
  firstSlideClone.removeAttribute('data-slide');
  firstSlideClone.classList.add('clone');
  track.appendChild(firstSlideClone);

  let currentIndex = 0;
  let isTransitioning = false;
  const duration = parseInt(carousel.dataset.autoplaySpeed || 5000);
  const autoplay = carousel.dataset.autoplay === 'true';
  const slideTransitionDuration = 700; // Match CSS transition duration

  // Set CSS variable for progress duration
  carousel.style.setProperty('--carousel-duration', duration + 'ms');

  function updateCarousel(instant = false) {
    if (instant) {
      track.style.transition = 'none';
    }

    // Slide transition
    track.style.transform = `translateX(-${currentIndex * 100}%)`;

    // Update slide active states for zoom effect
    slides.forEach((slide, index) => {
      if (index === currentIndex || (currentIndex === slides.length && index === 0)) {
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active');
      }
    });

    // Update clone active state
    if (currentIndex === slides.length) {
      firstSlideClone.classList.add('is-active');
    } else {
      firstSlideClone.classList.remove('is-active');
    }

    if (instant) {
      void track.offsetWidth; // Force reflow
      track.style.transition = '';
    }

    // Update pagination
    const paginationIndex = currentIndex % slides.length;
    const isOnClone = currentIndex === slides.length;

    paginationItems.forEach((item, index) => {
      const bar = item.querySelector('.hero-carousel__pagination-bar');

      if (index < paginationIndex) {
        // Previous slides - completed
        item.classList.remove('is-active');
        item.classList.add('is-completed');
        bar.style.width = '100%';
      } else if (index === paginationIndex) {
        // Current slide - active with animation
        item.classList.remove('is-completed');
        item.classList.add('is-active');
        // Reset animation
        bar.style.animation = 'none';
        bar.style.width = '0%';
        void bar.offsetWidth; // Force reflow
        // Don't start animation if we're on the clone (will restart after reset)
        if (autoplay && !instant && !isOnClone) {
          bar.style.animation = '';
        }
      } else {
        // Future slides - reset
        item.classList.remove('is-active', 'is-completed');
        bar.style.width = '0%';
        bar.style.animation = 'none';
      }
    });
  }

  function goToSlide(index) {
    if (isTransitioning) return;
    isTransitioning = true;

    currentIndex = index;

    // Handle infinite loop
    if (currentIndex > slides.length) {
      currentIndex = 1;
    } else if (currentIndex < 0) {
      currentIndex = slides.length - 1;
    }

    updateCarousel();

    // If we're at the cloned first slide, reset to real first slide after transition
    if (currentIndex === slides.length) {
      setTimeout(() => {
        currentIndex = 0;
        updateCarousel(true);
        isTransitioning = false;

        // Restart pagination animation for autoplay
        if (autoplay) {
          setTimeout(() => {
            const firstPaginationItem = paginationItems[0];
            const bar = firstPaginationItem.querySelector('.hero-carousel__pagination-bar');
            bar.style.animation = 'none';
            void bar.offsetWidth; // Force reflow
            bar.style.animation = '';
          }, 50);
        }
      }, slideTransitionDuration);
    } else {
      setTimeout(() => {
        isTransitioning = false;
      }, slideTransitionDuration);
    }
  }

  function nextSlide() {
    goToSlide(currentIndex + 1);
  }

  function prevSlide() {
    if (currentIndex === 0) {
      // Jump to last slide instantly, then transition to second-to-last
      currentIndex = slides.length;
      updateCarousel(true);
      setTimeout(() => {
        currentIndex = slides.length - 1;
        updateCarousel();
      }, 50);
    } else {
      goToSlide(currentIndex - 1);
    }
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }

  // Pagination clicks
  paginationItems.forEach((item, index) => {
    item.addEventListener('click', function() {
      if (index !== currentIndex && !isTransitioning) {
        goToSlide(index);
      }
    });
  });

  // Listen for animation end on active pagination bar
  paginationItems.forEach(item => {
    const bar = item.querySelector('.hero-carousel__pagination-bar');
    bar.addEventListener('animationend', function() {
      if (item.classList.contains('is-active') && autoplay) {
        nextSlide();
      }
    });
  });

  // Touch/Swipe support
  let touchStartX = 0;
  let touchEndX = 0;
  let isDragging = false;

  carousel.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
    isDragging = true;
  }, { passive: true });

  carousel.addEventListener('touchmove', function(e) {
    if (!isDragging) return;
    touchEndX = e.changedTouches[0].screenX;
  }, { passive: true });

  carousel.addEventListener('touchend', function(e) {
    if (!isDragging) return;
    isDragging = false;
    touchEndX = e.changedTouches[0].screenX;

    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
  }, { passive: true });

  // Initialize
  slides[0].classList.add('is-active');
  if (autoplay) {
    updateCarousel();
  }

  // Mark as initialized to enable transitions
  setTimeout(() => {
    carousel.classList.add('initialized');
  }, 100);
});
